// extracted by mini-css-extract-plugin
export default {"custom":"card_custom__MbtaT","lightBox":"card_lightBox__g51Hn","item":"card_item__BYSo2"};